import { type PaginatedQueryParams } from 'queries/queries-utils'
import { type GcpTargetType } from 'types/api/gcp/integrations'

type PaginatedGcpIntegrationsResourcesBaseQueryParams = {
  integrationId: string
  teamId: string
} & PaginatedQueryParams

export type PaginatedGcpIntegrationsResourcesAllQueryParams = {
  cloudRunRegion?: string[]
} & PaginatedGcpIntegrationsResourcesBaseQueryParams

export type PaginatedGcpIntegrationsResourcesComputeQueryParams = {
  resourceType?: GcpTargetType[]
} & PaginatedGcpIntegrationsResourcesBaseQueryParams

export type PaginatedGcpIntegrationsResourcesCloudRunQueryParams = {
  region: string[]
} & PaginatedGcpIntegrationsResourcesBaseQueryParams

export const gcpQueryKeys = {
  getIntegrationSetup: (teamId: string) =>
    ['gcp/integration-setup', { teamId }] as const,
  getIntegrationsResourcesAll: ({
    integrationId,
    ...params
  }: PaginatedGcpIntegrationsResourcesAllQueryParams) =>
    [`gcp/integrations/${integrationId}/resources/all`, params] as const,
  getIntegrationsResourcesCompute: ({
    integrationId,
    ...params
  }: PaginatedGcpIntegrationsResourcesComputeQueryParams) =>
    [`gcp/integrations/${integrationId}/resources/compute`, params] as const,
  getIntegrationsResourcesCloudRun: ({
    integrationId,
    ...params
  }: PaginatedGcpIntegrationsResourcesCloudRunQueryParams) =>
    [`gcp/integrations/${integrationId}/resources/cloud-run`, params] as const,
  getMetadataAuthorization: (teamId: string) =>
    ['gcp/metadata/authorization', { teamId }] as const
}
